import React from "react";

const DeleteConfirmation: React.FC<any> = ({ deleteEntity, acceptAction, cancelAction }): React.ReactElement => {
    return <div className={'delete-confirmation'}>
			<div className="confirmation-text">
				Are you sure you want to delete <strong>{deleteEntity}</strong>? This action cannot be undone.
			</div>
			<div className="confirm-actions">
				<button onClick={acceptAction} className={'active'}>Yes</button>
				<button onClick={cancelAction} className={'active'}>No</button>
			</div>
		</div>;
}

export default DeleteConfirmation;
